/*
 *
 * RecordControlPanel actions
 *
 */

import {
  GET_FILE_HISTORY_WATCHER,
  GET_FILE_HISTORY_SUCCESS,
  GET_FILE_HISTORY_FAILED,
  DOWNLOAD_FILE_WATCHER,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILED,
} from "./constants"

export function downloadFileWatcher(payload) {
  return {
    type: DOWNLOAD_FILE_WATCHER,
    payload,
  }
}

export function downloadFileSuccess(payload) {
  return {
    type: DOWNLOAD_FILE_SUCCESS,
    payload,
  }
}

export function downloadFileFailed(payload) {
  return {
    type: DOWNLOAD_FILE_FAILED,
    payload,
  }
}

export function getFileHistoryWatcher(payload) {
  return {
    type: GET_FILE_HISTORY_WATCHER,
    payload,
  }
}

export function getFileHistorySuccess(payload) {
  return {
    type: GET_FILE_HISTORY_SUCCESS,
    payload,
  }
}

export function getFileHistoryFailed(payload) {
  return {
    type: GET_FILE_HISTORY_FAILED,
    payload,
  }
}
